import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const useHeaderUtils = ({
  userIsManager,
  isManagerView,
  currentCompany,
}) => {
  const { formatMessage: f } = useIntl();

  const contextButtonProps = useMemo(() => {
    if (!userIsManager) {
      return null;
    }

    if (!isManagerView) {
      return {
        icon: ['far', 'check-circle'],
        text: f({ id: 'layout_header.answer_assessments' }),
      };
    }

    if (currentCompany) {
      return {
        icon: ['fas', 'industry'],
        text: currentCompany.name,
      };
    }

    return {
      icon: ['far', 'list-alt'],
      text: f({ id: 'layout_header.see_all_companies' }),
    };
  }, [f, userIsManager, isManagerView, currentCompany]);

  return { contextButtonProps };
};

export default useHeaderUtils;
